const Drgn = {
  symbol: 'drgn',
  color: '#000',
  colorIcon() {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill="none"><circle cx="16" cy="16" r="16" fill="#C91111"/><g fill="#FFF"><path opacity=".6" d="M9.4 20.78h2.818l-.072-7.327L22.64 26.776l-.033-15.732h-2.774l.072 7.401L9.404 5.087z"/><path d="M9.4 9.953l.016-4.851 13.183 16.752.055 4.942z"/></g></g>`;
  },
  plainIcon: c => {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" fill="${
      c ? c : this.color
    }" d="M9.403 9.957L9.4 20.78h2.818l-.072-7.327 8.28 10.513 2.228 2.83-.018-1.573-.029-14.179h-2.774l.072 7.386L9.577 5.306l-.173-.22v3.948l-.004.92.003.003zM16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16z"/><path d="M9.403 9.957l11.024 14.01-8.281-10.514.072 7.327H9.4l.003-10.823zm0-.923l.001-3.947.173.219-.161-.204-.013 3.932zm10.502 9.396l-.072-7.386h2.774l.03 14.18-.038-3.37-2.694-3.424z" opacity=".398"/>`;
  }
};
export default Drgn;
